export const loginValidate = (formData: any) => {
    let errors: any = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.username || formData.username.trim() === '') {
      errors.username = "Email is required";
    } else if (!emailRegex.test(formData.username)) {
      errors.username = "Please enter a valid email address";
    }

    if (!formData.password) {
      errors.password = "Password is required";
    }

    return errors;
  };

export const forgotPasswordValidate = (formData: any) => {
    const errors: any = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.email || formData.email.trim() === '') {
      errors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      errors.email = "Please enter a valid email address";
    }

    return errors;
  };
  
export const resetPasswordValidate = (formData: any) => {
    const errors: any = {};
    
    if (!formData.code || formData.code.trim() === '') {
      errors.code = "Verification code is required";
    }
    
    if (!formData.password) {
      errors.password = "Password is required";
    } else if (formData.password.length < 8) {
      errors.password = "Password must be at least 8 characters long";
    } else if (!/(?=.*[a-z])/.test(formData.password)) {
      errors.password = "Password must include at least one lowercase letter";
    } else if (!/(?=.*[A-Z])/.test(formData.password)) {
      errors.password = "Password must include at least one uppercase letter";
    } else if (!/(?=.*\d)/.test(formData.password)) {
      errors.password = "Password must include at least one number";
    } else if (!/(?=.*[!@#$%^&*(),.?":{}|<>])/.test(formData.password)) {
      errors.password = "Password must include at least one special character";
    }
    
    if (!formData.confirmPassword) {
      errors.confirmPassword = "Please confirm your password";
    } else if (formData.confirmPassword !== formData.password) {
      errors.confirmPassword = "Passwords do not match";
    }
    
    return errors;
  };

  export const signupValidate = (formData: any) => {
    const errors: any = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    // Validate email
    if (!formData.email || formData.email.trim() === '') {
      errors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      errors.email = "Please enter a valid email address";
    }
    
    // Validate password - Cognito requires at least 8 characters with uppercase, lowercase, number, and special character
    if (!formData.password) {
      errors.password = "Password is required";
    } else if (formData.password.length < 8) {
      errors.password = "Password must be at least 8 characters long";
    } else if (!/(?=.*[a-z])/.test(formData.password)) {
      errors.password = "Password must include at least one lowercase letter";
    } else if (!/(?=.*[A-Z])/.test(formData.password)) {
      errors.password = "Password must include at least one uppercase letter";
    } else if (!/(?=.*\d)/.test(formData.password)) {
      errors.password = "Password must include at least one number";
    } else if (!/(?=.*[!@#$%^&*(),.?":{}|<>])/.test(formData.password)) {
      errors.password = "Password must include at least one special character";
    }
    
    // Validate password confirmation
    if (!formData.confirmPassword) {
      errors.confirmPassword = "Please confirm your password";
    } else if (formData.confirmPassword !== formData.password) {
      errors.confirmPassword = "Passwords do not match";
    }
    
    // Terms and conditions
    if (!formData.termsAccepted) {
      errors.termsAccepted = "You must accept the terms and conditions";
    }
 
    return errors;
  };

  export const profileValidate = (formData: any) => {
    const errors: any = {};
    if (!formData.popular_track_stream) {
      errors.popular_track_stream = "This field is required";
    }
    if (!formData.songs_featured) {
      errors.songs_featured = "This field is required";
    }
    if (!formData.monthly_listeners) {
      errors.monthly_listeners = "This field is required";
    }
    if (!formData.perform_for_international_audience) {
      errors.perform_for_international_audience = "This field is required";
    }
    if (!formData.published_under_bmi) {
      errors.published_under_bmi= "This field is required";
    }
    return errors;
  };